import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import '../../../../src/assets/css/screens/customer/about us/About.css';
import Navbar from "../../../components/customer/home/Navbar/MyNavbar";
import Topbar from "../../../components/customer/home/topbar/Topbar";
import Footer from "../../../components/customer/home/footer/Myfooter";
import axios from "axios";
import AppContext from "../../../context/AppContext";

import LoginModal from '../../../components/customer/auth/loginModal/LoginModal';
import Storysection from '../../../subscreens/customer/home/aboutus/Storysection';
import WhoWeAre from '../../../subscreens/customer/home/aboutus/WhoWeAre';

const Aboutus = () => {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const {baseUrl} = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(false);
 const [counters, setCounters] = useState({
  professionals: 0,
  customers: 0,
  services: 0,
  cities: 0
});

  useEffect(() => {
    setIsVisible(true);
    
  }, []);

 useEffect(() => {

  setIsVisible(true);


  axios.get(`${baseUrl}/customer/herosectionstates`)
  .then(res=>{

    console.log("ABOUT STATS:",res.data);


  setCounters({

  professionals: res.data.experts,

  customers: res.data.happy_clients,

  services: res.data.services,

  cities: 0

});


  })
  .catch(err=>{

    console.log(
      "ABOUT STATS ERROR:",
      err.response?.data || err.message
    );

  });


},[baseUrl]);

  return (
    <>
     
      <Topbar/>
       <Navbar/>

      <div className="about-page-wrapper">
          <div className="about-simple-container">
            <h1 className="about-simple-title">About Us</h1>
            <p className="about-simple-subtitle">
              Your platform connecting customers with verified professionals.
            </p>
          </div>

        {/* Story Section */}
        <Storysection/>

        {/* Who We Are */}
        <WhoWeAre/>

        {/* Stats Section */}
        <section className="about-stats-section">
          <div className="about-stats-container">
            <div className="about-stats-grid">
   <div className="about-stat-box">
  <h3 className="about-stat-number">
    {(counters.professionals || 0).toLocaleString()}+
  </h3>
  <p>Verified Professionals</p>
</div>

<div className="about-stat-box">
  <h3 className="about-stat-number">
    {(counters.customers || 0).toLocaleString()}+
  </h3>
  <p>Happy Customers</p>
</div>

<div className="about-stat-box">
  <h3 className="about-stat-number">
    {(counters.services || 0).toLocaleString()}+
  </h3>
  <p>Services Completed</p>
</div>






              
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="about-cta-section">
          <div className="about-cta-container">
            <div className="about-cta-content">
              <h2 className="about-cta-title">Ready to Experience Quality Service?</h2>
              <p className="about-cta-text">
                Join thousands of satisfied customers who trust Picks4Tips for their home service needs
              </p>
              <div className="about-cta-buttons">
             <button
  className="about-cta-primary"
  onClick={() => setShowLoginModal(true)}
>
  Book a Service
</button>
                
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer/>

     <LoginModal
    isOpen={showLoginModal}
    onClose={() => setShowLoginModal(false)}
    onLoginSuccess={() => setShowLoginModal(false)}
/>
    </>
  );
};

export default Aboutus;